import createClient from 'openapi-fetch';
import { API_URL } from '../config';
import type { paths } from './schema';

/**
 * Typed client for the calls that *are* the session (login, refresh): no token, no automatic refresh.
 * Every other call uses `api` from ./client.
 */
export const sessionApi = createClient<paths>({ baseUrl: API_URL, credentials: 'include' });
